// extracted by mini-css-extract-plugin
module.exports = {"moduleGoals":"style-module__moduleGoals___1VF_8","btnGrayLink":"style-module__btnGrayLink___xf1-u"};